import { FieldType, ViewModelBase } from "@shoothill/core";
import { observable, action } from "mobx";
import { ServerViewModel } from "Globals/ViewModels/ServerViewModel";
import { HeaderModel } from "./HeaderModel";

export class HeaderViewModel extends ViewModelBase<HeaderModel> {
    public server: ServerViewModel = new ServerViewModel();

    // #region Constants

    // #endregion Constants

    private static _instance: HeaderViewModel;
    public static get Instance() {
        return this._instance || (this._instance = new this());
    }

    public constructor() {
        super(new HeaderModel(), false);

        this.setDecorators(HeaderModel);
    }

    @observable
    public errorMessage: string = "";

    @observable
    public hasLoaded = false;

    @action
    private setHasLoaded(val: boolean) {
        this.hasLoaded = val;
    }

    @action
    public cleanUp = () => {
        // TODO Any Cleanup Code here. e.g. if  a user or project or client etc, wipe it from the instance on page shutdown
    };

    // #region Approval Modals

    // #endregion Approval Modals

    public async isFieldValid(fieldName: keyof FieldType<HeaderModel>): Promise<boolean> {
        const { isValid, errorMessage } = await this.validateDecorators(fieldName);

        this.setError(fieldName, errorMessage);
        this.setValid(fieldName, isValid);

        return isValid;
    }

    public afterUpdate: undefined;
    public beforeUpdate: undefined;
}
